import { getUserClaims } from "features/application/application-slice";
import { fetch_media_statistics } from "features/auto-thunks";
import { get_all_mediaStatistic } from "features/mediaStatistic/mediaStatistic-slice";
import WatchLaterTwoToneIcon from '@mui/icons-material/WatchLaterTwoTone';
import { ProcessedMedia } from "models";
import { useEffect, useState } from "react";
import ParentSize from '@visx/responsive/lib/components/ParentSize';
import RedQuickColumnChart from "./RedQuickColumnChart";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import TitleService from "title-service";

export default function MediaStatisticComponent(props: { processedMedia: ProcessedMedia }) {
    const all_media_statistics = useSelector(get_all_mediaStatistic);
    const claims = useSelector(getUserClaims);
    const [isLoading, setIsLoading] = useState(false);
    const media_statistic = all_media_statistics.find(x => x.mediaId === (props?.processedMedia?.media as any));
    useEffect(() => {
        if (props?.processedMedia?.media) {
            let isCancelled = false;
            const fetchData = async () => {
                setIsLoading(true);
                try {
                    await dispatch(fetch_media_statistics({
                        playerId: claims?.player,
                        mediaId: props?.processedMedia?.media
                    }));
                } catch (error) {
                    if (!isCancelled) {
                        console.log(error);
                    }
                } finally {
                    setIsLoading(false);
                }
            };
            fetchData();
        }
    }, [props?.processedMedia?.id])
    if (!media_statistic) {
        return <></>
    }
    let hasValues = media_statistic.hashValue || [0];
    let maxValue = Math.max(...hasValues);
    let weightedValues = hasValues.map(x => maxValue ? x / maxValue : x);
    return (
        <>
            <h2>{TitleService('Views')} {maxValue}</h2>
            <div style={{ height: 400 }}>
                <ParentSize>{({ width, height }) => <RedQuickColumnChart
                    width={width}
                    height={height}
                    categories={[media_statistic.mediaStatisticType]} series={[{
                        name: media_statistic.name,
                        data: weightedValues
                    }]} />}</ParentSize>
            </div>
        </>
    )
}